import { ProviderCardProps } from "@app/projects/network-assessment/maps/network-coverage-map/interfaces";
import { ProviderCard } from "@app/projects/network-assessment/maps/network-coverage-map/components/ProviderCard";
import {
  NETWORK_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR,
  NETWORK_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR
}from "@app/projects/network-assessment/maps/network-coverage-map/NetworkCoverageMapsConstants";
import { JSX } from "react"
import { ProviderBadgeStyle } from "@app/projects/enumerators";
import ProviderActionStatusBadge from "@app/shared/ProviderActionStatusBadge";

export const NetworkProviderCard = (
  { provider, isSelected, onClick }: ProviderCardProps
): JSX.Element => {

  const highlightedStyles = isSelected ?
    {
      backgroundColor: NETWORK_PROVIDER_CARD_HIGHLIGHT_BACKGROUND_COLOR,
      borderColor: NETWORK_PROVIDER_CARD_HIGHLIGHT_BORDER_COLOR,
      borderStyle: 'solid',
      borderWidth: '3px'
    } : {} ;

  return (
    <ProviderCard highlightedStyles={highlightedStyles} provider={provider} onClick={onClick}>
      <p><strong>Serves:</strong> {provider.servesPercent}%</p>
      <div className="me-2">
        <ProviderActionStatusBadge
          badgeStyle={ProviderBadgeStyle.Outline}
          status={provider.scenarioModelProviderStatus}
          hideWhenNullActionStatus={true}
        />
      </div>
    </ProviderCard>
  )
}

